import { BaseModel } from '../core/abstractions/base.model';

export class AgendaItemModel extends BaseModel {
    vote: number;
    voteDescription: string;
    generalMeetingId: number;
    gmAgendaItemNumber: number;
    number: string;
    votingCouponNumber?: number;
    description: string;
    parentGmAgendaItemDescription: string;
    parentGmAgendaItemNumber: number;
    boardOfDirectorsForOptionsNumber: number;
    boardOfDirectorsAgainstOptionsNumber: number;
    votingStartedDateTime?: Date;
    votingEndedDateTime?: Date;
    isVotingOpen: boolean;
    resultYesPercent?: number;
    resultNoPercent?: number;
    resultAbstentionPercent?: number;
    presenceTotalVotes?: number;
    presenceMajorityVotes?: number;
    presenceMajorityVotesLabel: string;
    resultYes?: number;
    resultNo?: number;
    resultAbstention?: number;
    showResults: boolean;
    resultAcceptedTime?: Date;

    // TODO: this model is getting big, need to split into more specific models for different views (components) //

    // this is used only in general-meeting-agenda component
    hasChildren: boolean;
    childrenCount = 0;
    childrenVoteOpen: number[] = [];
    childrenVoteFinished: number[] = [];
    childrenNotStarted: number[] = [];
    childrenVoteAccepted: number[] = [];
    childrenVoteNotAccepted: number[] = [];

    // this is only used in agenda-items component
    hasError = false;

    constructor(init?: Partial<AgendaItemModel>) {
        super();
        Object.assign(this, init);
    }
}
